<template>
  <div id="app">
    <router-view :key="version"></router-view>

    <NotificationPermission
      v-if="showPermissionPrompt"
      @permission-granted="onPermissionGranted"
      @permission-denied="onPermissionDenied"
    />
    <NotificationOTP
      :otp = "otp"
      :expired_at = "expired_at"
    />
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>

<script>
import { messaging, isFirebaseMessagingSupported } from "@/util/firebase-utils";
import NotificationPermission from "@/components/NotificationPermission";
import NotificationOTP from "@/components/NotificationOTP";
import LoaderComponent from "@/components/LoaderComponent";
import { detectIncognito } from "detectincognitojs";

export default {
  data() {
    return {
      version               : process.env.VUE_APP_NOCACHE_VERSION,
      showPermissionPrompt  : false,
      otp                   : "",
      expired_at            : "",
      isLoading             : false,
      broadcastChannel      : null
    };
  },
  components: {
    NotificationPermission,
    LoaderComponent,
    NotificationOTP
  },
  mounted() {
    try {
      const language = localStorage.getItem("lang");
      this.$i18n.locale = language ? language : "en-EN";

      const urlParams = new URLSearchParams(window.location.search);
      const otp = urlParams.get('otp');
      const expired_at = urlParams.get('expired_at');

      if (otp && expired_at) {
        this.handleOTP(otp,expired_at);
      }

      detectIncognito().then((result) => {
        if(result.isPrivate == false){
          if ('Notification' in window) {
            const permission = Notification.permission;
            const savedToken = localStorage.getItem("notification_token");
            const is_allow = localStorage.getItem("permission");

            if (permission !== "granted" && !savedToken && is_allow !== "false" && isFirebaseMessagingSupported()) {
              this.showPermissionPrompt = true;
            }

            if (isFirebaseMessagingSupported()) {
              messaging.onMessage((payload) => {
                console.log("📥 Foreground message received");
                this.handleMessage(payload);
              });
            } else {
              console.warn("📵 Firebase messaging is not supported on this browser");
            }
          }
          else{
            console.warn("Browser does not support notifications");
          }
          
          
          if ('BroadcastChannel' in window) {
            this.broadcastChannel = new BroadcastChannel('firebase-messaging-channel');
            this.broadcastChannel.onmessage = (event) => {
              console.log("📥 Background message received");
              this.handleMessage(event.data);
            };
          }
        }
      });
    } catch (err) {
      console.error("❌ Error in mounted() on iOS:", err);
    }
  },
  methods: {
    handleMessage(payload){
      if(payload.data['trans_no'] && payload.data['trans_no'].includes("QR")){
        window.location.href = `${this.$router.resolve({
            path: "scan-qr",
            query: { trans_no: payload.data['trans_no'] }
        }).href}`;
      }
      else{
        this.handleOTP(payload.data['code'],payload.data['expired_at']);
      }
    },
    async onPermissionGranted() {
      this.isLoading = true;
      this.showPermissionPrompt = false;
      window.location.reload();
    },
    onPermissionDenied() {
      this.showPermissionPrompt = false;
      localStorage.setItem("permission","false");
      console.warn("User denied notification permission");
    },
    handleOTP(otp,expired_at) {
      if (otp && expired_at) {
        this.otp = otp;
        this.expired_at = expired_at;
        this.$bvModal.show('modal-otp');
      }
    }
  },
  beforeDestroy() {
      if (this.broadcastChannel) {
          this.broadcastChannel.close(); // Tutup BroadcastChannel
          this.broadcastChannel = null;
      }
  }
};
</script>
